import { useTranslation } from 'react-i18next';

export type QrStatus = 'active' | 'inactive' | 'archived';

/** The state a code is in, most important first: archived answers the question before paused does. */
export function statusOf(qrCode: { isArchived: boolean; isActive: boolean }): QrStatus {
  return qrCode.isArchived ? 'archived' : qrCode.isActive ? 'active' : 'inactive';
}

/**
 * The code's state, as a pill beside its name rather than a row in the metadata list: it is the first thing
 * anybody opening a code wants to know. The word is inside the pill, so the colour never carries it alone.
 */
export function StatusPill({ status }: { status: QrStatus }) {
  const { t } = useTranslation();

  const label: Record<QrStatus, string> = {
    active: t('qrCode.active'),
    // The consequence, not just the state: "inactive" does not say that the redirect now answers 404.
    inactive: t('qrCode.inactiveDetail'),
    archived: t('qrCode.archived'),
  };

  return (
    <span className={`status-pill ${status}`}>
      <span className="status-pill__dot" aria-hidden="true" />
      {label[status]}
    </span>
  );
}
